import { render } from "./CurrencyFilterBody.vue?vue&type=template&id=33bf3ad1"
import script from "./CurrencyFilterBody.vue?vue&type=script&lang=js"
export * from "./CurrencyFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__